/* eslint-disable */
import {
  Card,
  CardContent,
  Grid,
  Typography,
} from "@mui/material";
import Item from "../../utils/Item";
import PrecioVentaContadoLista from "./PrecioVentaContadoLista";
import { formatEsferaCilindroAdicion } from "../../utils/utils";

//
// ###########################################################################
//
const DatosCristal = ({ articulo, showPrecio = true }) => {

  //
  // ################################################################################
  //
  return (
    <>
      {articulo && (
        <>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
                Cristal
              </Typography>

              <Grid container spacing={2}>
                <Item label="Producto" value={articulo.descripcion_cristal_producto} />
                <Item label="Descripción" value={articulo.descripcion} />
                <Item label="Modelo" value={articulo.modelo} />
                <Item label="Marca" value={articulo.descripcion_bl_cr_marca} />
                <Item label="Submarca" value={articulo.descripcion_bl_cr_submarca} />
                <Item label="Material" value={articulo.descripcion_bl_cr_material} />
                <Item label="Tipo" value={articulo.descripcion_bl_cr_tipo} />
                <Item label="Color" value={articulo.descripcion_bl_cr_color} />
                <Item label="Origen" value={articulo.descripcion_cr_origen} />
                <Item label="Esfera" value={formatEsferaCilindroAdicion(articulo.esfera)} />
                <Item label="Cilindro" value={formatEsferaCilindroAdicion(articulo.cilindro)} />
                <Item label="Ojo" value={articulo.ojo.toUpperCase()} />
              </Grid>
            </CardContent>
          </Card>

          {showPrecio && (
            <Card sx={{ mt: 2 }}>
              <CardContent>
                <PrecioVentaContadoLista precioVentaContado={articulo.precio_venta_contado} precioVentaLista={articulo.precio_venta_lista} />
              </CardContent>
            </Card>
          )}
        </>
      )}
    </>
  );
};
export default DatosCristal;
